document.addEventListener('DOMContentLoaded', () => {
  // The Bürger page pills moved into blocks/opening-hours (own view script).
  const wrappers = document.querySelectorAll('.footer-status-wrapper');

  wrappers.forEach((wrapper) => {
    const btn = wrapper.querySelector('.js-footer-status-btn');
    if (!btn) return;

    btn.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent document click from immediately closing

      // Close other tooltips
      wrappers.forEach((w) => {
        if (w !== wrapper && w.classList.contains('is-open')) {
          w.classList.remove('is-open');
          const otherBtn = w.querySelector('.js-footer-status-btn');
          if (otherBtn) {
            otherBtn.setAttribute('aria-expanded', 'false');
          }
        }
      });

      const isOpen = wrapper.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen.toString());
    });
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    wrappers.forEach((wrapper) => {
      if (!wrapper.contains(e.target) && wrapper.classList.contains('is-open')) {
        wrapper.classList.remove('is-open');
        const btn = wrapper.querySelector('.js-footer-status-btn');
        if (btn) {
          btn.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      wrappers.forEach((wrapper) => {
        if (wrapper.classList.contains('is-open')) {
          wrapper.classList.remove('is-open');
          const btn = wrapper.querySelector('.js-footer-status-btn');
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
            btn.focus(); // Return focus to button when closing via keyboard
          }
        }
      });
    }
  });
});
